import { useQuery } from "@tanstack/react-query";
import { getPlatformUser } from "@/api/v1-jwt/tenancy/tenancy";
import { useAuth } from "@/providers/auth";

export const usePlatformUser = ({
  userId,
  clientId,
  queryKey,
  queryFn,
  enabled,
  ...config
} = {}) => {
  let { cognitoId, clientId: id } = useAuth();
  const user = userId || cognitoId;
  const client = clientId || id;
  return useQuery({
    queryKey: ["tenancy", client, "user", user],
    queryFn: async () => getPlatformUser({ userId: user, clientId: client }),
    enabled: !!client || !!user,
    ...config,
  });
};
